// Authentication service: handles login, token storage, and auth utilities

const BASE_TOKEN_URL = 'https://trpliveapi1.tripbox.co.kr/Token';
const STORAGE_KEYS = {
  token: 'authToken',
  refreshToken: 'authRefreshToken',
  expirationTime: 'authExpirationTime',
  custNo: 'authCustNo',
  userName: 'authUserName',
};

function getFromStorage(key) {
  const v = localStorage.getItem(key);
  if (v !== null && v !== undefined) return v;
  return sessionStorage.getItem(key);
}

export function getToken() {
  return getFromStorage(STORAGE_KEYS.token) || '';
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) return false;
  const exp = getFromStorage(STORAGE_KEYS.expirationTime);
  if (!exp) return true; // if no exp, assume valid
  try {
    const expDate = new Date(exp);
    return expDate.getTime() > Date.now();
  } catch {
    return true;
  }
}

export function clearAuth() {
  Object.values(STORAGE_KEYS).forEach((k) => {
    localStorage.removeItem(k);
    sessionStorage.removeItem(k);
  });
}

function saveAuth({ token, refreshToken, expirationTime, custNo, userName }, remember) {
  const store = remember ? localStorage : sessionStorage;
  if (token) store.setItem(STORAGE_KEYS.token, token);
  if (refreshToken) store.setItem(STORAGE_KEYS.refreshToken, refreshToken);
  if (expirationTime) store.setItem(STORAGE_KEYS.expirationTime, expirationTime);
  if (custNo) store.setItem(STORAGE_KEYS.custNo, String(custNo));
  if (userName) store.setItem(STORAGE_KEYS.userName, userName);
}

export async function login(userName, userPw, remember = true, custNo = '') {
  let resolvedCustNo = custNo;
  if (!resolvedCustNo) {
    const listUrl = `${BASE_TOKEN_URL}/Token_ERP_CUST_LIST2?userName=${encodeURIComponent(
      userName
    )}&userPw=${encodeURIComponent(userPw)}`;
    const listResp = await fetch(listUrl);
    if (!listResp.ok) {
      throw new Error(`고객사 목록 조회 실패: ${listResp.status}`);
    }
    const listData = await listResp.json();
    const validList = Array.isArray(listData)
      ? listData.filter((x) => x && x.cust_no)
      : [];

    if (validList.length === 0) {
      throw new Error('ID 또는 암호가 올바르지 않습니다');
    }

    if (validList.length > 1) {
      const err = new Error('로그인할 회사를 선택해주세요.');
      err.code = 'MULTI_CUST';
      err.custList = validList;
      throw err;
    }

    resolvedCustNo = validList[0].cust_no;
  }

  // 2) Get auth token for the resolved custNo
  const tokenUrl = `${BASE_TOKEN_URL}/Token_ERP2?userName=${encodeURIComponent(
    userName
  )}&userPassword=${encodeURIComponent(userPw)}&custNo=${encodeURIComponent(
    resolvedCustNo
  )}&userPath=CW`;
  const tokenResp = await fetch(tokenUrl);
  if (!tokenResp.ok) {
    throw new Error(`토큰 발급 실패: ${tokenResp.status}`);
  }
  const tokenData = await tokenResp.json();

  if (!tokenData || !tokenData.token) {
    throw new Error('유효한 토큰이 응답에 없습니다.');
  }

  saveAuth(
    {
      token: tokenData.token,
      refreshToken: tokenData.refreshToken,
      expirationTime: tokenData.expirationTime,
      custNo: resolvedCustNo,
      userName,
    },
    remember
  );

  return tokenData;
}

export function getAuthInfo() {
  return {
    token: getFromStorage(STORAGE_KEYS.token) || '',
    refreshToken: getFromStorage(STORAGE_KEYS.refreshToken) || '',
    expirationTime: getFromStorage(STORAGE_KEYS.expirationTime) || '',
    custNo: getFromStorage(STORAGE_KEYS.custNo) || '',
    userName: getFromStorage(STORAGE_KEYS.userName) || '',
  };
}
